// Source:  https://github.com/sparkalow/angular-truncate/blob/master/src/truncate.js
export function WordFilter() {
    'ngInject';
    return (input, words) => {
        if (isNaN(words)) {
            return input;
        }
        if (words <= 0) {
            return '';
        }
        if (input) {
            var inputWords = input.split(/\s+/);
            if (inputWords.length > words) {
                input = inputWords.slice(0, words).join(' ') + '…';
            }
        }
        return input;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/filters/WordFilter.js